import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { rxResource } from '@angular/core/rxjs-interop'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { Observable } from 'rxjs'
import { PdfComponent } from '../pdf/pdf.component'
import { ResourceLoadingComponent } from '../resource-loading/resource-loading.component'

export interface PdfDialogAction {
  icon: string
  tooltip: string
  /** Bekommt das bereits geladene Dokument — die Aktion loest keine zweite Abfrage aus. */
  run: (data: string | Blob) => void
}

export interface PdfDialogData {
  /** Ueberschrift und zugleich Dateiname beim Herunterladen. */
  title: string
  data$: Observable<string | Blob>
  /**
   * Zusaetzliche Icon-Knoepfe vor „Schließen". Sie reisen als Closure herein, damit der Dialog
   * keine App-Begriffe (Dokumentart) und keine App-Abhaengigkeit kennt: `libs/shared` darf nichts aus
   * einer App importieren, und dieser Barrel liegt im Initial-Bundle aller drei Apps.
   */
  actions?: PdfDialogAction[]
}

@Component({
  selector: 'lib-pdf-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule, PdfComponent, ResourceLoadingComponent],
  templateUrl: './pdf-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './pdf-dialog.component.scss',
})
export class PdfDialogComponent {
  readonly data: PdfDialogData = inject(MAT_DIALOG_DATA)

  readonly pdfResource = rxResource({ stream: () => this.data.data$ })

  constructor() {
    inject(MatDialogRef).addPanelClass('lib-pdf-dialog-panel')
  }

  runAction(action: PdfDialogAction) {
    if (this.pdfResource.hasValue()) {
      action.run(this.pdfResource.value())
    }
  }
}
